import React from "react";
import { Outlet } from "react-router-dom";
import TinyCommons from "@tiny/tiny-commons";
import useDashboard from "./Dashboard.hooks";

const Dashboard = React.memo(() => {
  const { config } = useDashboard();
  return (
    <>
      <TinyCommons config={config} />
      <Outlet />
    </>
  );
});

export default Dashboard;
